import React from 'react';
import { Col, Row, Container, Navbar } from 'reactstrap';

const Footer = () => {
  return (
    <Navbar style={{ backgroundColor: 'black' }}>
      <Container id={'footer-container'} fluid style={{ color: '#dddddd' }}>
        <Row style={{ width: '100%' }}>
          <Col xs={{ size: 12 }}>
            <div
              className={'mt-2 mb-2'}
              style={{
                fontSize: '0.7rem',
                lineHeight: '100%',
                textAlign: 'center',
              }}
            >
              <div className="footerHeader">
                <a
                  className="footerLink"
                  href="mailto:admin@thecara.org?subject=Contact%20request%20for%20CARA"
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  Contact
                </a>

                <a
                  className={'footerLink'}
                  href={'https://www.thecara.org/privacy'}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  Privacy
                </a>

                <a
                  className={'footerLink'}
                  href={'https://www.thecara.org/terms-of-use'}
                  target={'_blank'}
                  rel="noopener noreferrer"
                >
                  Terms of Use
                </a>

                <p>&copy; Copyright {new Date().getFullYear()} Center for Asset Retirement Accountability</p>
              </div>

              <p className={'disclaimer'}>
                Direct or indirect reproduction or distribution of any article without prior written permission from The Center
                for Asset Retirement Accountability is a violation of Federal Copyright Law.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </Navbar>
  );
};

export default Footer;
